<template>
  <component :is="element" :class="[textSize, { isMobileView }]" :id="id">
    <slot></slot>
  </component>
</template>

<script>
export default {
  props: {
    element: {
      type: String,
      default: 'ul'
    },
    isMobileView: {
      type: Boolean,
      default: false,
      required: false
    },
    textSize: {
      type: String,
      default: 'medium'
    },
    id: String
  }
};
</script>

<style lang="scss">
.large {
  font-size: 40px;
  letter-spacing: 2px;
}

.medium-large {
  font-size: 30px;
}

.medium {
  font-size: 25px;
}

.small {
  font-size: 21px;
}

.smaller {
  font-size: 19px;
}

.smallest {
  font-size: 15px;
}

.isMobileView {
  margin: 0px;
}
</style>
